import { isUnifiedFieldGroupID } from '@modules/common/utils';

export const shouldRenderCustomGroup = (groupKey: string) => {
  return isUnifiedFieldGroupID(groupKey);
};
